module.exports = __webpack_public_path__ + "static/media/404.906fc181.png";